import { recordingStatusFromUploadStage } from '@/features/rpa/recorder/lib/recording-status-from-upload-stage';
import type { RecordingEntry } from '@/features/rpa/recorder/model/types';
import type { Workflow } from '@/tauri/rpa-recorder/types';
import type { RecorderUploadSidecar } from '@/tauri/rpa-recorder/upload-types';

/** A missing sidecar cannot prove that the recording finished uploading. */
export function fallbackUploadSidecarForPersistedWorkflow(
  workflow: Workflow
): RecorderUploadSidecar {
  return {
    stage: 'failed',
    recordingId: null,
    idempotencyKey: workflow.id,
    recordingName: workflow.name,
    uploadAttempts: 0,
    lastAttemptAt: null,
    failureKind: 'upload',
    errorCode: 'UPLOAD_STATE_NOT_FOUND',
    errorMessage: 'Recording upload state could not be read',
  };
}

export function recordingEntryFromPersistedWorkflow(
  workflow: Workflow,
  uploadState: RecorderUploadSidecar
): RecordingEntry {
  const status = recordingStatusFromUploadStage(uploadState.stage);

  return {
    sessionId: workflow.id,
    name: uploadState.recordingName?.trim() || workflow.name,
    description: workflow.description ?? null,
    status,
    uploadStage: uploadState.stage,
    createdAtMs: workflow.createdAtMs,
    isNew: false,
    ...(uploadState.stage === 'failed' && uploadState.errorCode
      ? { errorCode: uploadState.errorCode }
      : {}),
    ...(uploadState.failureKind ? { failureKind: uploadState.failureKind } : {}),
    ...(uploadState.recordingId ? { recordingId: uploadState.recordingId } : {}),
  };
}
